import { makeAutoObservable, runInAction } from 'mobx';
import { ReactNode } from 'react';
import { Common } from 'src/AppState/Common';
import { AutoWeakMap } from 'src_common/common/mobx-utils/AutoWeakMap';

export type ToastVariantType = 'success' | 'error';

export type ToastType = {
    variant: ToastVariantType;
    title: string;
    message?: string | ReactNode;
    button?: ReactNode;
    persistent?: boolean;
};

export class ToasterState {
    private toastData: ToastType | null = null;
    private timer: NodeJS.Timeout | null = null;
    private timerClose: NodeJS.Timeout | null = null;
    private countdown: number = 0;
    private hover: boolean = false;
    public isClosing: boolean = false;

    public static get = AutoWeakMap.create((_common: Common) => new ToasterState());

    private constructor() {
        makeAutoObservable(this);
    }

    public setToast = (toast: ToastType): void => {
        if (this.toast !== null) {
            this.closeToast();
        }
        setTimeout(() => {
            runInAction(() => {
                this.isClosing = false;
                this.toastData = toast;
                this.clearTimer();

                if (toast.persistent !== true) {
                    this.countdown = 5;
                    this.timer = setInterval(() => runInAction(() => this.tick()), 1000);
                }
            });
        }, 0);
    };

    private tick(): void {
        if (this.hover === false) {
            this.countdown -= 1;
        }
        if (this.countdown <= 0) {
            this.closeToast();
        }
    }

    public mouseEnter(): void {
        this.hover = true;
    }
    public mouseLeave(): void {
        this.hover = false;
    }

    public get toast(): ToastType | null {
        return this.toastData;
    }

    public closeToast(): void {
        this.isClosing = true;

        this.timerClose = setTimeout(() => {
            runInAction(() => {
                this.toastData = null;
            });
        }, 300);

        this.clearTimer();
    }

    private clearTimer(): void {
        if (this.timer !== null) {
            clearInterval(this.timer);
        }
        if (this.timerClose !== null) {
            clearTimeout(this.timerClose);
        }
    }
}
